import { getDashboardPartnersControllerListQueryKey } from "@/api/__generated__/dashboard-partners/dashboard-partners";

/**
 * Query keys to invalidate after any partner mutation (create / update / delete /
 * reorder). The list key is passed without params so react-query prefix-matches
 * every scoped variation (platform / organization / league).
 */
export const PARTNERS_INVALIDATE_KEYS = [getDashboardPartnersControllerListQueryKey()];
